
export const shipmentHeaderFields = [
    {
        name: "shipmentNumber",
        label: "Shipment Number",
        type: "text",
        readOnly: true,
        autoGenerated: true,
        prefetch: true,
        prefetchFormat: "SHIP####",
        hiddenOnCreate: true
    },
    { name: "externalShipmentNumber", label: "External Shipment Number", type: "text", readOnly: true },
    { name: "loadId", label: "Load ID", type: "text", description: "Load ID from 3PL or Carrier" },
    { name: "source", label: "Source", type: "text", readOnly: true, description: "Internal/Marketplace Name, Auto Fill", defaultValue: "INTERNAL" },

    // NEW: Create Using - required select
    // {
    //     name: "createUsing",
    //     label: "Create Using",
    //     type: "select",
    //     // required: true,
    //     options: [
    //         { value: "sku", label: "SKU ID" },
    //         { value: "so", label: "SO/STO Number" }
    //     ],
    //     description: "Choose whether to build this shipment using SKU(s) or SO number(s).",
    //     required: true
    // },

    // Conditional: show SKU search only when createUsing === 'sku'
    // {
    //     name: "skuSearch",
    //     label: "SKU ID",
    //     type: "text",            // rendered as a searchable input (GenericFormTab uses searchable flag)
    //     searchable: true,        // GenericFormTab will render input + search button for fields with searchable:true
    //     conditional: { field: "createUsing", value: "sku" },
    //     description: "Search SKU ID (single or multiple depending on your workflow).",
    //     required: true
    // },

    // Conditional: show orderNumbers only when createUsing === 'so'

    { name: "status", label: "Status", type: "text", options: ["New", "Packed", "In Transit", "Delivered", "Closed"], readOnly: true },
    { name: "totalQty", label: "Total Qty", type: "number", readOnly: true },
    { name: "totalWeight", label: "Total Weight ", type: "number", readOnly: true },
    { name: "totalVolume", label: "Total Volume", type: "number", readOnly: true },
    // { name: "shipmentDate", label: "Shipment Date", type: "date", readOnly: true, description: "Auto fetch in PP" },
    { name: "closedDate", label: "Closed Date", type: "date", readOnly: true },
];


export const sourceSellerAddressFields = [
    { name: "sourceName", label: "Source / Seller Name", type: "supplierLookup", description: "Auto fetched from selected orders", required: true },
    { name: "sourceAddressLine1", label: "Address Line 1", type: "text", required: true },
    { name: "sourceAddressLine2", label: "Address Line 2", type: "text" },
    { name: "sourceAddressLine3", label: "Address Line 3", type: "text" },
    { name: "sourceAddressLine4", label: "Address Line 4", type: "text" },
    { name: "sourceCity", label: "City", type: "text", required: true },
    { name: "sourceState", label: "State", type: "text", required: true },
    { name: "sourceCountry", label: "Country", type: "text", required: true },
    { name: "sourceReference", label: "Source Reference", type: "text" },
    { name: "sourceContact", label: "Contact", type: "text" },
    { name: "sourceEmail", label: "Email", type: "email" }
];

export const destinationBuyerAddressFields = [
    { name: "destinationName", label: "Destination / Buyer Name", type: "customerLookup", description: "Auto fetched from selected orders", required: true },
    { name: "destinationAddressLine1", label: "Address Line 1", type: "text", required: true },
    { name: "destinationAddressLine2", label: "Address Line 2", type: "text" },
    { name: "destinationAddressLine3", label: "Address Line 3", type: "text" },
    { name: "destinationAddressLine4", label: "Address Line 4", type: "text" },
    { name: "destinationCity", label: "City", type: "text", required: true },
    { name: "destinationState", label: "State", type: "text", required: true },
    { name: "destinationCountry", label: "Country", type: "text", required: true },
    { name: "destinationReference", label: "Destination Reference", type: "text" },
    { name: "destinationContact", label: "Contact", type: "text" },
    { name: "destinationEmail", label: "Email", type: "email" }
];

export const billToFields = [
    // { name: "billToSameAsDestination", label: "Bill To same as Destination", type: "checkbox", description: "Checkbox for 'Same as Destination Details' - Autofill on check" },
    { name: "billToName", label: "Bill To Name", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToAddressLine1", label: "Address Line 1", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToAddressLine2", label: "Address Line 2", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToAddressLine3", label: "Address Line 3", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToAddressLine4", label: "Address Line 4", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToCity", label: "City", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToState", label: "State", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToCountry", label: "Country", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToContact", label: "Contact", type: "text", conditional: { field: "billToSameAsDestination", value: false } },
    { name: "billToEmail", label: "Email", type: "email", conditional: { field: "billToSameAsDestination", value: false } }
];

export const invoiceFields = [
    { name: "invoiceNumber", label: "Invoice Number", type: "text" },
    { name: "invoiceDate", label: "Invoice Date", type: "date" },
    { name: "invoiceType", label: "Invoice Type", type: "select", options: ["Tax Invoice", "Proforma", "Credit Note", "Debit Note"] },
    { name: "invoiceAmount", label: "Invoice Amount", type: "number" },
    { name: "paymentTerms", label: "Payment Terms", type: "text" },
    { name: "invoiceUpload", label: "Invoice Upload", type: "file" }
];

export const carrierFieldsPP = [
    // { name: "shippingMode", label: "Shipping Mode", type: "select", options: ["Surface", "Air", "Express", "Courier"], required: false },
    { name: "carrierName", label: "Carrier Name", type: "text", required: true },
    { name: "awbNumber", label: "AWB / Tracking Number", type: "text" },
    { name: "carrierAddressLine1", label: "Address Line 1", type: "text", required: true },
    { name: "carrierAddressLine2", label: "Address Line 2", type: "text" },
    { name: "carrierCity", label: "City", type: "text", required: true },
    { name: "carrierState", label: "State", type: "text", required: true },
    { name: "carrierCountry", label: "Country", type: "text", required: true },
    { name: "carrierContact", label: "Contact", type: "text" },
    { name: "carrierEmail", label: "Email", type: "email" }
];

export const loadFieldsPP = [
    { name: "vehicleNumber", label: "Vehicle Number", type: "text", required: true },
    { name: "vehicleDetails", label: "Vehicle Details", type: "text" },
    { name: "driverDetails", label: "Driver Details", type: "text", required: true },
    // { name: "expectedDepartureDate", label: "Expected Departure Date", type: "date", required: true },
    { name: "actualDepartureDate", label: "Actual Departure Date", type: "date", required: true },
    { name: "expectedArrivalDate", label: "Expected Arrival Date", type: "date", required: true },
    { name: "actualArrivalDate", label: "Actual Arrival Date", type: "date" }
];

export const podFields = [
    { name: "podDetails", label: "POD Details", type: "textarea" },
    { name: "podUpload", label: "Upload POD", type: "file" }
];

export const udfFields = [
    { name: "createdBy", label: "Created By", type: "text", readOnly: true },
    { name: "createdAt", label: "Created Date", type: "date", readOnly: true },
    { name: "updatedBy", label: "Updated By", type: "text", readOnly: true },
    { name: "updatedDate", label: "Updated Date", type: "date", readOnly: true },
    { name: "shipmentUDF1", label: "Shipment UDF 1", type: "text" },
    { name: "shipmentUDF2", label: "Shipment UDF 2", type: "text" },
    { name: "shipmentUDF3", label: "Shipment UDF 3", type: "text" },
    { name: "notes", label: "Notes", type: "textarea" }
];

/*
  Item table fields represent each line item that gets pulled from selected orders.
  Some fields are readOnly / pre-populated from order details, while others are editable.
*/
export const itemTableFields = [
    // internal use - not shown in UI
    { name: "shipmentRef", label: "Shipment Ref", type: "text", hidden: true },

    { name: "orderNumber", label: "Order Number", type: "text", readOnly: true },
    { name: "lineNumber", label: "Line #", type: "number", readOnly: true },
    { name: "skuId", label: "SKU ID", type: "text", selectable: true }, // Multiple selection allowed
    { name: "description", label: "Description", type: "text", readOnly: true },
    { name: "pack", label: "Pack", type: "text", readOnly: true },
    { name: "uom", label: "UOM", type: "text", readOnly: true },
    { name: "orderQty", label: "Order Qty", type: "number", readOnly: true },
    { name: "openQty", label: "Open Qty", type: "number", readOnly: true },
    { name: "dispatchQty", label: "Dispatch Qty", type: "number", editable: true },
    { name: "destinationCity", label: "Destination City", type: "text", readOnly: true },
    { name: "qcRequired", label: "QC Required", type: "checkbox" },
    { name: "statusLine", label: "Status", type: "text", readOnly: true },
    { name: "receivedQty", label: "Received Qty", type: "number", readOnly: true },
    { name: "receivedDate", label: "Received Date", type: "date", readOnly: true },
    { name: "grNumber", label: "GR Number", type: "text", readOnly: true },

    // Add details (optional fields for each item)
    { name: "itemWeight", label: "Item Weight (kg)", type: "number" },
    { name: "itemVolume", label: "Item Volume (m³)", type: "number" },
    { name: "lpn", label: "LPN", type: "text" },
    { name: "lotBatch", label: "Lot / Batch", type: "text" },
    { name: "manufactureDate", label: "Manufacture Date", type: "date" },
    { name: "expiryDate", label: "Expiry Date", type: "date" },
    { name: "deliverByDate", label: "Deliver By Date", type: "date" },
    { name: "bestByDate", label: "Best By Date", type: "date" },
    { name: "itemUDF", label: "Item UDF", type: "text" }
];

export const allShipmentFieldGroups = [
    shipmentHeaderFields,
    sourceSellerAddressFields,
    destinationBuyerAddressFields,
    billToFields,
    invoiceFields,
    carrierFieldsPP,
    loadFieldsPP,
    podFields,
    udfFields,
    itemTableFields
];

// helper to build default (null) values for all fields

export function buildDefaultShipmentFormData() {
    const defaults = {};

    // allShipmentFieldGroups must be an array of groups (each group is an array of field defs)
    allShipmentFieldGroups.forEach(group =>
        group.forEach(f => {
            // If a field has a defaultValue, use it, otherwise set null
            if (!(f.name in defaults)) {
                defaults[f.name] = f.defaultValue !== undefined ? f.defaultValue : null;
            }
        })
    );

    // sensible defaults (keep/backfill existing logic)
    if (defaults.status == null) defaults.status = "New";
    if (defaults.billToSameAsDestination == null) defaults.billToSameAsDestination = false;
    // total fields start at 0
    if (defaults.totalQty == null) defaults.totalQty = null;
    if (defaults.totalWeight == null) defaults.totalWeight = null;
    if (defaults.totalVolume == null) defaults.totalVolume = null;

    return defaults;
}



export default {
    shipmentHeaderFields,
    sourceSellerAddressFields,
    destinationBuyerAddressFields,
    billToFields,
    invoiceFields,
    carrierFieldsPP,
    loadFieldsPP,
    podFields,
    udfFields,
    itemTableFields,
    allShipmentFieldGroups,
    buildDefaultShipmentFormData
};
